import axios from 'axios';

import apiLogger from '../utils/apiLogger';
import styledConsole from '../utils/styledConsole';

let accountData={
    "id": null,
    "email": null,
    "department": null,
    "status": null,
    "role": null,
    "token": null,
    "createdTime": null,
    "updatedTime":null 
};

if(localStorage.getItem("account")){
    accountData=JSON.parse(localStorage.getItem("account"));
}
else if(window.location.pathname!="/"&&window.location.pathname!="/callback"){
    alert("계정정보가 없습니다. 재접속 바랍니다.");
    window.location.href="/"
}

const useApi = axios.create({
    baseURL: process.env.REACT_APP_NGP_SERVICE_URL,
    withCredentials: false,
    headers: {
        'Content-Type': 'application/json' ,
        'Authorization': `Bearer ${accountData.token}`
    },
});

const isDev = process.env.NODE_ENV !== 'production';

useApi.interceptors.response.use(
    (res) => {
        const { status, config: reqData, data: resData } = res;
        if (isDev) apiLogger({ status, reqData, resData });
        return res;
    },
    async (error) => {
        try {
            if (error.name && error.name === "CanceledError") {
                return Promise.reject(error);
            }
            if (error.response.status === 401) {
                alert("계정정보가 만기되었습니다. 재접속 바랍니다.")
                window.location.href="/"
            }
            const { response: res, config: reqData } = error || {};
            const { status } = res || {};
            const isUnAuthError = status === 401;
            const isExpiredToken = status === 444;

            if (isDev) {
                apiLogger({ status, reqData, resData: error, method: 'error' });
            }
            if (isExpiredToken) {
            }
            if (isUnAuthError) {
            }

            return Promise.reject(error);
        } catch (e) {

            styledConsole({
                method: 'error',
                topic: 'UN_HANDLED',
                title: 'axios-interceptor',
                data: e,
            });
        }
    }
);

export default useApi;